import {Pipe, PipeTransform} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {PermissionsService} from '../permissions.service';
import {DasAction} from '../types';

@Pipe({
  name: 'dasDisabled'
})
export class DasDisabledPipe implements PipeTransform {
  constructor(private _permissionsService: PermissionsService) {}

  /**
   * Returns the negation of the action requested.
   *
   * @param action {DasAction}             DAS action the user is looking to take
   * @returns      {Observable<boolean>}   An observable resolving whether the user cannot do the action requested
   */
  public transform(action: DasAction): Observable<boolean> {
    return this._permissionsService.can(action).pipe(
      map((canAction: boolean) => {
        return !canAction;
      })
    );
  }
}
